document.addEventListener('alpine:init', () => {
  Alpine.data('QuantityStepper', () => {
    return {
      quantity: 1,
      init() {
        // Always ensure quantity starts at 1
        this.quantity = 1;

        // Handle dropdown quantity if present
        if (this.dropdownQuantity) {
          if (this.dropdownQuantity === '10+') {
            this.quantity = 10;
          } else {
            this.quantity = parseInt(this.dropdownQuantity, 10) || 1;
          }
        }

        // Set the input value immediately
        this.$nextTick(() => {
          if (this.$refs.quantityInput) {
            this.$refs.quantityInput.value = this.quantity;
          }
        });
      },
      dispatchInputChange() {
        if (this.$refs.quantityInput) {
          this.$refs.quantityInput.dispatchEvent(
            new Event('change', { bubbles: true })
          );
        }
      },
      decreaseQuantity() {
        if (this.quantity > 1) {
          this.quantity--;
          this.dispatchInputChange();
        }
      },
      increaseQuantity() {
        this.quantity++;
        this.dispatchInputChange();
      },
    };
  });
});
